document.addEventListener('DOMContentLoaded', function () {
  // true = replace cart with this one item; false = keep existing cart
  const clearCartFirst = true;

  document.body.addEventListener('submit', function (e) {
    const form = e.target;

    // Only product add forms inside any quick-shop modal/wrapper
    const inQuickShop = form.closest('[id^="QuickShop-"], .quick-shop, [data-quickshop], .modal--quickshop');
    const isProductAdd = form.matches('form[action*="/cart/add"]');

    if (inQuickShop && isProductAdd) {
      e.preventDefault();
      const formData = new FormData(form);
      const goCheckout = () => { window.location.href = '/checkout'; };
      const add = () => fetch('/cart/add.js', { method: 'POST', body: formData, credentials: 'same-origin' });

      if (clearCartFirst) {
        fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
          .then(add)
          .then(goCheckout)
          .catch(goCheckout);
      } else {
        add().then(goCheckout).catch(goCheckout);
      }
    }
  });

  // Safety net if the theme dispatches a product:added event
  document.addEventListener('product:added', function () {
    window.location.href = '/checkout';
  });
});


